<template>
  <b-card no-body>
    <b-card-body>
      <b-card-title class="d-flex justify-content-between align-items-center">
        Kullanıcı için yetkileri seçin
        <b-button size="sm" variant="outline-primary" :class="{'bg-primary text-white':allSelected}" @click="toggleAllPermissions">
          Tümünü Seç/Kaldır
        </b-button>
      </b-card-title>
      <b-form-checkbox-group v-model="internalValue">
        <b-row>
          <b-col
            cols="12"
            md="4"
            lg="3"
            v-for="(group, category) in groupedPermissions"
            :key="category"
            class="mb-2"
          >
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="text-primary text-capitalize mb-1">{{ category }}</h5>
              <b-button size="sm" variant="outline-primary" :class="{'bg-primary text-white':isCategorySelected(category)}" @click="toggleCategory(category)">
                Tümünü Seç/Kaldır
              </b-button>
            </div>
            <div v-for="perm in group" :key="perm.id">
              <b-form-checkbox :value="perm.permission_key">
                {{ perm.name }}
              </b-form-checkbox>
            </div>
            <hr />
          </b-col>
        </b-row>
      </b-form-checkbox-group>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardTitle,
  BFormCheckbox,
  BFormCheckboxGroup,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue';

export default {
  name: 'PermissionsSelector',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    BCard,
    BCardBody,
    BButton,
    BCardTitle,
    BFormCheckbox,
    BFormCheckboxGroup,
    BRow,
    BCol,
  },
  data() {
    return {
      permissions: [],
      // groupedPermissions is now a computed property again
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    allSelected() {
      const allKeys = this.permissions.map((p) => p.permission_key);
      // Ensure allKeys has items before checking all conditions
      return allKeys.length > 0 && allKeys.every((p) => this.internalValue.includes(p));
    },
    // Reverted groupedPermissions to a computed property
    groupedPermissions() {
      const groups = {};
      this.permissions.forEach((perm) => {
        const category = perm.category_name || 'Genel';
        if (!groups[category]) groups[category] = [];
        groups[category].push(perm);
      });
      return groups;
    },
  },
  created() {
    this.fetchPermissions();
  },
  methods: {
    async fetchPermissions() {
      try {
        const res = await this.$http.get('/manage/permissions');
        if (res.data.success) {
          this.permissions = res.data.data;
          // No need to call groupPermissionsByCategory() here anymore,
          // as groupedPermissions is computed.
        }
      } catch (err) {
        console.error('Yetkiler alınamadı', err);
      }
    },
    // Removed groupPermissionsByCategory method as it's no longer needed
    // now that groupedPermissions is a computed property.
    toggleAllPermissions() {
      if (this.allSelected) {
        this.$emit('input', []);
      } else {
        const allKeys = this.permissions.map((p) => p.permission_key);
        this.$emit('input', allKeys);
      }
    },
    toggleCategory(category) {
      const perms = this.groupedPermissions[category].map((p) => p.permission_key);
      const current = this.internalValue;
      const isAllSelected = perms.every((p) => current.includes(p));

      if (isAllSelected) {
        const newVal = current.filter((p) => !perms.includes(p));
        this.$emit('input', newVal);
      } else {
        const newVal = Array.from(new Set([...current, ...perms]));
        this.$emit('input', newVal);
      }
    },
    isCategorySelected(category) {
      // Added optional chaining and default empty array for robustness
      const perms = this.groupedPermissions[category]?.map((p) => p.permission_key) || [];
      // Ensure perms has items before checking all conditions
      return perms.length > 0 && perms.every((p) => this.internalValue.includes(p));
    },
  },
};
</script>